export const WALLET_ADDRESSES = {
  dev: '6Nueic7eZQ9QhN9Eu89ygxsrMM5wQoimQyzUBU4nca47',
  bonanza: '7Bp5q6pwfAePFVr16BkAbmBnxV5f1Jp6ibEwMWiPmkGC',
  pools: {
    mini: 'AD4bgExJKw9avqfGLHhKGsXus5VoUEGSp9jj5xcbSb5Z',
    standard: '5DuGzamXPUcRmqMvGbVraeGNDgMfrNXQJciQ9ccT9y1F',
    mega: 'CyxgcjieLTZaF21j88z8MdC1raaXzHy1Eh5HGU5Dj51w',
  }
};

export const GAME_CONFIGS = {
  mini: {
    id: 'mini',
    label: 'Mini Coop',
    emoji: '🐔',
    gridSize: 4,
    totalSquares: 16,
    entryFee: 0.02,
    directBuyFee: 0.025,
    poolShare: 0.80,
    devShare: 0.10,
    bonanzaShare: 0.10,
    maxMultiplier: 29,
    route: '/drop/mini',
    localStorageKey: 'chickenDrop_mini',
  },
  standard: {
    id: 'standard',
    label: 'Standard Coop',
    emoji: '🐔',
    gridSize: 5,
    totalSquares: 25,
    entryFee: 0.02,
    directBuyFee: 0.025,
    poolShare: 0.80,
    devShare: 0.10,
    bonanzaShare: 0.10,
    maxMultiplier: 46,
    route: '/drop/standard',
    localStorageKey: 'chickenDrop_standard',
  },
  mega: {
    id: 'mega',
    label: 'Mega Coop',
    emoji: '🐔',
    gridSize: 10,
    totalSquares: 100,
    entryFee: 0.10,
    directBuyFee: 0.25,
    poolShare: 0.80,
    devShare: 0.10,
    bonanzaShare: 0.10,
    maxMultiplier: 197,
    route: '/drop/mega',
    localStorageKey: 'chickenDrop_mega',
  },
  bonanza: {
    id: 'bonanza',
    label: 'BONANZA DRAW',
    emoji: '🎰',
    gridSize: 10,
    totalSquares: 100,
    entryFee: 0,
    poolShare: 1.0,
    devShare: 0,
    bonanzaShare: 0,
    maxMultiplier: null,
    route: '/drop/bonanza',
    localStorageKey: 'chickenDrop_bonanza',
  },
};

export default GAME_CONFIGS;
